import InputMask from "react-input-mask";
import "./style.scss";
import { StackIcon } from "shared/ui";

const DateInput = ({
  disabled,
  day,
  handleDateChange,
  errorMessage,
  value,
}) => {
  const dateHandler = (e) => {
    const value = e.target.value;
    handleDateChange(day, value);
  };

  return (
    <div className={`date-input ${disabled ? "date-input-disabled" : ""}`}>
      <div className="date-input__wrapper">
        <InputMask
          mask="99:99-99:99"
          value={value}
          disabled={disabled}
          placeholder="Enter working hours"
          onChange={dateHandler}
        />

        <StackIcon icon="clock" width={16} className="date-input__icon" />
      </div>
      {errorMessage.length && !disabled ? (
        <div className="date-input__error">{errorMessage}</div>
      ) : null}
    </div>
  );
};

export default DateInput;
